import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/auth-surface.css';

export function FingerprintIcon({ size = 28 }) {
    return <svg width={size} height={size} viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true"><path d="M5 14a11 11 0 0 1 22 0M9 26c3-4 2-8 2-12a5 5 0 0 1 10 0c0 7-1 11-4 15M5 20c1-2 1-4 1-6M8 12a8 8 0 0 1 16 2c0 5 0 8-2 12M16 11c-3 0-2 4-2 7 0 4-1 7-3 10M17 16c0 5-1 8-2 10M27 18c0 3-1 6-2 8" /></svg>;
}
export default function AuthShell({ children, signup = false }) {
    return <main className={`auth-page ${signup ? 'auth-page--signup' : ''}`}>
        <div className="auth-shell">
            <aside className="auth-story">
                <Link to="/login" className="auth-brand"><span className="auth-monogram">IG<span /></span><span>IPTIC <strong>Galkoye</strong></span></Link>
                <figure className="auth-poster"><img src="/photo.png" alt="Sciences et numérique au Niger — formations IPTIC Galkoye." fetchpriority="high" /></figure>
            </aside>
            <section className="auth-panel">
                <nav className="auth-tabs" aria-label="Accès au compte"><Link to="/login" aria-current={!signup ? 'page' : undefined}>Connexion</Link><Link to="/inscription" aria-current={signup ? 'page' : undefined}>Inscription</Link></nav>
                {children}
                <p className="auth-privacy"><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" aria-hidden="true"><rect x="4" y="8" width="12" height="9" rx="2" /><path d="M6 8V6a4 4 0 0 1 8 0v2" /></svg>Vos données biométriques restent sur votre appareil.</p>
            </section>
        </div>
    </main>;
}
